export { default } from "bullitttime-embermodelsevent/adapters/start-timing-record";
